import Reveal from "@/components/base/Reveal";
import { themeGardens } from "@/mocks/home";

export default function ThemeGardens() {
  const featured = themeGardens.filter((g) => g.image);
  const rest = themeGardens.filter((g) => !g.image);

  return (
    <section id="gardens" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-grid-line"></i>
            主题园体系
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            16 大主题园，总有一方属于你
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-2xl mx-auto leading-relaxed">
            每个主题园拥有独立页面、独立地块、独立社群与独立活动体系。
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((garden, i) => (
            <Reveal key={garden.id} delay={i * 60}>
              <a
                href="#contact"
                className="group block h-full bg-white rounded-lg border border-background-200 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-300 cursor-pointer"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={garden.image}
                    alt={garden.name}
                    title={`${garden.name} · 味聚华夏农耕酵素农场`}
                    loading="lazy"
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-white/90 text-primary-700 text-xs font-medium">
                    {garden.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {garden.name}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed mt-2 line-clamp-2">
                    {garden.desc}
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-8">
          <div className="bg-white rounded-lg border border-background-200 p-6">
            <p className="text-sm font-semibold text-foreground-950 mb-4">更多主题园</p>
            <div className="flex flex-wrap gap-2.5">
              {rest.map((garden) => (
                <a
                  key={garden.id}
                  href="#contact"
                  className="inline-flex items-center gap-1.5 text-xs md:text-sm px-3.5 py-2 rounded-full bg-background-100 border border-background-200 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 hover:border-primary-200 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-leaf-line text-accent-600"></i>
                  {garden.name}
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}